<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <side-bar
                :background-color="sidebarBackground"
                short-title="SRB - Zona Privada"
                title="SRB - Zona Privada">
            <template slot="links">
                <sidebar-item :link="{name: 'Inicio',icon: 'ni ni-tv-2 text-primary',path: '/dashboard'}" />
                <sidebar-item v-if="type=='admin'" :link="{name: 'Jugadores',icon: 'ni ni-bold-right text-primary',path: '/admin/jugadores'}" />
                <sidebar-item v-if="type=='admin'" :link="{name: 'Grupos',icon: 'ni ni-bold-right text-primary',path: '/admin/grupos'}" />
                <sidebar-item v-if="type=='admin'" :link="{name: 'Presupuestos',icon: 'ni ni-bold-right text-primary',path: '/admin/presupuestos'}" />
                <sidebar-item v-if="type=='admin'" :link="{name: 'Pagos de jugadores',icon: 'ni ni-bold-right text-primary',path: '/admin/pagos/1/1/1'}" />
<!--                <sidebar-item v-if="type=='admin'" :link="{name: 'Entrenadores',icon: 'ni ni-bold-right text-primary',path: '/admin/entrenadores'}" />-->
<!--                <sidebar-item v-if="type=='admin'" :link="{name: 'Balones',icon: 'ni ni-bold-right text-primary',path: '/admin/balones'}" />-->
            </template>
        </side-bar>
        <div class="main-content" :data="sidebarBackground">
            <dashboard-navbar></dashboard-navbar>

            <div @click="toggleSidebar">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <!-- your content here -->
                    <router-view></router-view>
                </fade-transition>
                <content-footer v-if="!$route.meta.hideFooter"></content-footer>
            </div>
        </div>
    </div>
</template>
<script>
    import DashboardNavbar from './DashboardNavbar.vue';
    import ContentFooter from './ContentFooter.vue';
    import {FadeTransition} from 'vue2-transitions';

    export default {
        components: {
            DashboardNavbar,
            ContentFooter,
            FadeTransition
        },
        data() {
            return {
                sidebarBackground: 'primary', //vue|blue|orange|green|red|primary
                type: this.$store.getters.type
            };
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
        }
    };
</script>
<style lang="scss">
</style>
